import React, { useState, useEffect } from "react";
import { Modal, Button, Checkbox, Spin } from "antd";
import { withDomains, RESTExecutor } from "../../lib/domain";
import { JsonEditor as Editor } from "jsoneditor-react";
import "jsoneditor-react/es/editor.min.css";
import ace from "brace";

const ReversalConfig = (props) => {
  const [visible, setVisible] = useState(false);
  const [delTxn, setDelTxn] = useState();
  const [config, setConfig] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const list_config = RESTExecutor.list()
    .config({
      label: "reversal_config_upload",
    })
    .callbacks(
      (success) => {
        let rowsData = (success.result && success.result.rows) || [];
        let filteredData = JSON.parse(JSON.stringify(rowsData));
        console.log("filteredData", filteredData);
        setConfig(filteredData.config);
        setDelTxn(filteredData.delete_transaction);
        setIsLoading(false);
      },
      (error) => {
        console.log(error);
      }
    )
    .connect(props.domains.activity);

  const send_config = RESTExecutor.post()
    .config({
      label: "reversal_config_upload",
    })
    // .callbacks(
    //   (success) => {
    //     console.log(success);
    //   },
    //   (error) => {
    //     console.log(error.error_message);
    //   }
    // )
    .connect(props.domains.activity);

  const handleClick = () => {
    setVisible(true);
    setIsLoading(true);
    list_config.forId(props.data_id).execute();
  };

  const handleOk = () => {
    setVisible(false);
    send_config
      .forId(props.data_id)
      .execute({ config: config, delete_transaction: delTxn });
    // console.log({ config: { config: config }, delete_transaction: delTxn });
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleCheckbox = (e) => {
    // console.log(`checked = ${e.target.checked}, id=${props.data_id}`);
    setDelTxn(e.target.checked);
  };

  const handleConfig = (json) => {
    setConfig(json);
    // console.log(json);
  };

  return (
    <>
      <Button type="link" onClick={handleClick}>
        Config
      </Button>
      <Modal
        title="Reversal Upload Config"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {isLoading ? (
          <Spin />
        ) : (
          <>
            <div className="json-editor-wrapper">
              <Editor
                mode={Editor.modes.code}
                value={config || {}}
                onChange={handleConfig}
                className="small-json-editor"
                // statusBar={false}
                ace={ace}
              />
            </div>
            <Checkbox checked={delTxn} onChange={handleCheckbox}>
              Delete Transaction
            </Checkbox>
          </>
        )}
      </Modal>
    </>
  );
};

export default withDomains(ReversalConfig, "activity");
